/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mobile_Uploads_RemainingInputs */

const en_mobile_uploads_remaining = /** @type {(inputs: Mobile_Uploads_RemainingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} upload`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} uploads`);
	return /** @type {LocalizedString} */ ("mobile_uploads_remaining");
};

const es_mobile_uploads_remaining = /** @type {(inputs: Mobile_Uploads_RemainingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} subida`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} subidas`);
	return /** @type {LocalizedString} */ ("mobile_uploads_remaining");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} upload" |
* | "other" | "{count} uploads" |
*
* @param {Mobile_Uploads_RemainingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_uploads_remaining = /** @type {((inputs: Mobile_Uploads_RemainingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Uploads_RemainingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_uploads_remaining(inputs)
	return en_mobile_uploads_remaining(inputs)
});